import React, { useState } from 'react';
import logo from '../../assets/img/logo.svg';

function TimesheetDetails({ timesheet, onUpdate, onDeselect }) {

    const handleChange = (field, value) => {
        const updated = { ...timesheet, [field]: value };
        onUpdate(updated);
    };

    if (!timesheet) {
        return <div className="timesheet-details"><p>Sélectionnez un relevé à gauche.</p></div>;
    }

    return (
        <div className="timesheet-details">
            { window.innerWidth <= 1100 &&
                (<div className={`status ${timesheet.status === 'À FAIRE' ? 'todo' : 'archived'}`}>
                        {timesheet.status}
                    </div>
                )}
            {/* Bouton retour visible uniquement en mobile */}
            <div className="timesheet-details-head">
                <img src={logo} alt="icon" />
                <div>
                <p>{timesheet.date}</p>
                <h3>{timesheet.name}</h3>
                <p>{timesheet.role}</p>
                </div>
                { window.innerWidth > 1100 &&
                (<div className={`status ${timesheet.status === 'À FAIRE' ? 'todo' : 'archived'}`}>
                    {timesheet.status}
                </div>
                )}</div>
            <div className="timesheet-details-body">
                <div className={"left"}>
                <div>
                    <h4>Début de mission</h4>
                    <input type={"time"} id="start-time" name="start-time" value={timesheet.startTime} onChange={(e) => handleChange("startTime", e.target.value)} />
                </div>
                <div>
                    <h4>Fin de mission</h4>
                    <input type={"time"} id="end-time" name="end-time" value= {timesheet.endTime} onChange={(e) => handleChange("endTime", e.target.value)} />
                </div>
                <div>
                    <h4>Durée de la pause</h4>
                    <input type={"time"} id="break-time" name="break-time" value={timesheet.breakTime} onChange={(e) => handleChange("breakTime", e.target.value)} />
                </div>
                <div>
                    <h4>Heures travaillées</h4>
                    <p> {timesheet.workedHours} </p>
                </div>
                <div>
                    <h4>Comment s'est passée la mission ?</h4>
                    {/* Rajouter la rating bar ici */}
                </div>
                <div>
                    <h4 htmlFor={"comment"}>Commentaire (facultatif)</h4>
                    <textarea id={"comment"} name={"comment"} placeholder={"Observations liées à la mission (heures supplémentaires, retard, absence, accident de travail…)"} />
                    <button className={"btn fill green"}>Valider le relevé d'heures</button>
                </div>
                {onDeselect && window.innerWidth <= 1100 && (
                    <button className="btn empty" onClick={onDeselect}>
                        ⬅ Retour
                    </button>
                )}
                </div>
            </div>
        </div>
    );
}

export default TimesheetDetails;
